import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { pad } from '@teem/helpers/functions';
import { environment } from '@teem/environments/environment';
import { DeliveryDurationComponent } from '@teem/store-module/components/product-information/components/delivery-duration/delivery-duration.component';
declare var $: any;

@Component({
  selector: 'delivery',
  templateUrl: './delivery.component.html',
  styleUrls: ['./delivery.component.scss']
})
export class DeliveryComponent implements OnInit {
  @Input() formId: string;
  @Input() form;
  @Input() storeInformationForm;
  @Output() onSelect: EventEmitter<FormGroup> = new EventEmitter();
  @Output() onSubmit: EventEmitter<FormGroup> = new EventEmitter();

  isSubmitted: boolean = false;
  selectedWeekDays: any = [];
  hours: Array<string> = [];
	minutes: Array<string> = [];
	moment: any = moment;
  minValue: number = environment.minDeliveryDiscount;
  maxValue: number = environment.maxDeliveryDiscount;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    for (let i = 0; i <= 23; i++) {
			this.hours.push(pad(i, 2, 0))
		}

		for (let j = 0; j <= 59; j++) {
			this.minutes.push(pad(j, 2, 0))
		}

    if (this.formId == 'mrsool') {
      this.maxValue = environment.maxDeliveryDiscount; 
    }

    this.selectedWeekDays = this.form.value.days;

    this.updateMinValidation();
  }

  deliveryDiscount(value) {
    if (value > this.maxValue) {
      value = environment.maxDeliveryDiscount;
      if (this.formId == 'mrsool') {
        value = environment.maxDeliveryDiscount; 
      }
    }

    if (value <= this.minValue) {
      value = 0;
    }

    this.form.get('delivery_discount')?.setValue(value);

    this.updateMinValidation();
  }

  submit() {
    this.isSubmitted = true;
    if (this.form.valid) {
      // this.onSubmit.emit(this.form);
      this.isSubmitted = false;
      this.activeModal.close(this.form)
    }
  }

  editDiscountDuration(deliveryType: string) {
    const modalRef = this.modalService.open(DeliveryDurationComponent, { windowClass: 'delivery-duration-popup' });
    modalRef.componentInstance.formType = null;//this.formType;
    modalRef.componentInstance.storeInformationForm = this.storeInformationForm;
    modalRef.componentInstance.form = this.form;    
    modalRef.componentInstance.formId = deliveryType;//this.formId;

    modalRef.result.then(result => {
      this.form = result
      this.selectedWeekDays = this.form.value.days
    }, fallbackResult => {
      // this.onCancel.emit(this.form);
    });
  }

  newFormatIn24HoursTime(t: any) {
		return moment(`${t.hours}:${t.minutes}:00}`, 'HH:mm:ss').format('HH:mm:ss')
	}

  get expiryTimeGroup() {
    return this.form.get('discount_expiry_time_group') as FormGroup;
  }


  onChangeExpiryTime() {
    const expiryTimeValue = this.expiryTimeGroup.value;
    this.form.get('discount_expiry_time').setValue(this.newFormatIn24HoursTime(expiryTimeValue));

		setTimeout(function () {
			$('select[nice-select]').niceSelect('update');
		}, 100);
	}

  newFormatHoursMin(time: any) {
		return moment(`${time}`, 'HH:mm').format('HH:mm')
	}

  updateMinValidation() {
    const discount = this.form.get('delivery_discount')?.value;
    const minOrder = this.form.get('minimum_order_size');
    const minDiscount = this.form.get('minimum_discount_size');

    minOrder?.setValidators([Validators.required, Validators.min(discount)]);
    minOrder?.updateValueAndValidity();

    minDiscount?.setValidators([Validators.required, Validators.min(discount)]);
    minDiscount?.updateValueAndValidity();
  }

}
